const content: { [key: string]: string } = {
  title: "Notice",
  message:
    "Due to regulations in China, business information that is specific to the China market will be adapted and delayed. Please call the Amway China LGS Hotline at (+86) 2085-198-556 or contact your China LGS AM with any questions about China business information.",
};

export default content;
